import type { ThemeVariant } from '@/shared/ui/theme-tokens'

export const QUIZ_PAGE_VARIANT: ThemeVariant = 'purple'

/** 0 = sem limite, como no backend. */
export const formatTimeLimit = (seconds: number): string => {
  if (!seconds) return 'Sem limite de tempo'

  const minutes = Math.floor(seconds / 60)
  const rest = seconds % 60

  if (!minutes) return `${rest}s`
  if (!rest) return `${minutes} min`

  return `${minutes} min ${rest}s`
}

/** Cronômetro do aluno: mm:ss a partir dos segundos restantes. */
export const formatCountdown = (seconds: number): string => {
  const safe = Math.max(seconds, 0)
  const minutes = Math.floor(safe / 60)
  const rest = safe % 60

  return `${String(minutes).padStart(2, '0')}:${String(rest).padStart(2, '0')}`
}

export const formatAttempts = (maxAttempts: number): string =>
  maxAttempts ? `${maxAttempts} tentativa(s)` : 'Tentativas ilimitadas'

/**
 * Onde a retomada deve abrir. Quem volta ao quiz precisa cair na primeira
 * pergunta SEM resposta, não na pergunta 1 — reabrir e ter de clicar "Próxima"
 * até achar onde parou queima o tempo que já está correndo.
 *
 * Com tudo respondido, volta para a última: o passo seguinte ali é finalizar.
 */
export const firstUnansweredIndex = (
  questions: { selected_option_id: number | null }[]
): number => {
  const pending = questions.findIndex(item => item.selected_option_id === null)

  if (pending >= 0) return pending

  return Math.max(questions.length - 1, 0)
}
